 
<div style="text-align: center;" *ngIf="wordLimit > 0">    
    <p>Expected Word Count: {{wordLimit}}</p>
    <div class="gauge">
        <div class="gauge-fill" [style.width.%]="gaugePercentage"
            [ngStyle]="{'background-color': getGaugeColor ?  'var(--primary)' : 'red'}" >
            <span style="position: absolute; left: 45%;">{{textcount > 0 ? textcount + '/' + wordLimit + ' Words': ''}} </span>
        </div>
    </div>
</div>
<quill-editor *ngIf="(!scored && !teacherView); else viewMode" #editor id={{questionID}} [(ngModel)]="answeredText" (onEditorCreated)="checkCount()" (onContentChanged)="checkCount()"> 
</quill-editor>

<ng-template #viewMode>
    <quill-view #viewer id={{questionID}} [content]="answeredText" (onEditorCreated)="checkCount()" (onContentChanged)="checkCount()"></quill-view>
</ng-template>